module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"mobileDesignInformationModal\" title=\"Mobile Design\" style=\"display: none;\">\r\n\r\n    <div class=\"row\" style=\"padding: 0 0 10px 15px; width: 100%\">\r\n        <div class=\" col-md-12\" id=\"text1\">\r\n            Great!  Your app is now ready for you to optimize for your tablet and phone users.\r\n            If at any time you decide you do not want this app to be mobile, simply click on\r\n            the App Properties, and uncheck the box!\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" style=\"padding: 10px 0 10px 15px; width: 100%\">\r\n            <div><img alt=\"Phone\" style=\"padding: 0 100px\" src=\"")
    ; __append( require('AllowMobileDisplay.jpg') )
    ; __append("\" /> </div>\r\n    </div>\r\n\r\n</div>\r\n\r\n")
  }
  return __output;

}